@let blok = block();

<h3 class="app-tariff-table--title">
    {{ blok.title }}
</h3>

<table class="app-tariff-table--wrapper border-separate lg:border-spacing-y-4">
    <thead class="app-tariff-table--header"
           [style.grid-template-columns]="columnsStyle()">
    <tr class="app-tariff-table--header-row-text">
        <td [attr.colspan]="(blok.columns?.length || 0) + 1">{{ blok.headerRowText }}</td>
    </tr>
        @for (column of blok.columns; track column._uid) {
            <tr app-tariff-table-column
                [block]="column">
            </tr>
        }
    </thead>
    <tbody>
        @for (row of blok.rows; track row._uid) {
            @if (row.title) {
                <tr class="block lg:table-row">
                    <td colspan="4" class="p-4 italic">
                        {{ row.title }}
                    </td>
                </tr>
            }
            <tr app-tariff-table-row-group
                class="block mb-4"
                [block]="row"
                [columns]="blok.columns"
                [columnsStyle]="columnsStyle()"
                [titleColumnStartStyle]="titleColumnStartStyle()">
            </tr>
        }
    </tbody>

    @for (footerRow of blok.footer; track footerRow._uid) {
        <tfoot app-tariff-table-footer-row
               [columnsStyle]="columnsStyle()"
               [block]="footerRow"
               [columns]="blok.columns">
        </tfoot>
    }
</table>
